import React, { FunctionComponent } from 'react';

import clsx from 'clsx';

import { Feature } from '@domains/main-page';

import { NewProductsPageSlug, PromoPageSlug } from '@utils/constants';
import { NEW_PRODUCTS_FEATURE_STOCK_IMAGE_SET, PROMO_FEATURE_STOCK_IMAGE_SET } from '@utils/images';
import { makeCategoryRoute, makeNewsDetailsRoute } from '@utils/route';

import { useEmbla } from '@hooks/use-embla';

import { Container } from '@components/common/Container/Container';
import { Link } from '@components/common/Link/Link';
import { Picture } from '@components/common/Picture/Picture';
import { SliderNavigation } from '@components/common/SliderNavigation/SliderNavigation';

import styles from './FeatureSlider.module.scss';

const promoFeatureStock: Feature = {
    title: 'Акции',
    news_slug: '',
    background_image: PROMO_FEATURE_STOCK_IMAGE_SET,
    mobile_background_image: PROMO_FEATURE_STOCK_IMAGE_SET,
};

const newProductsFeatureStock: Feature = {
    title: 'Новинки',
    news_slug: '',
    background_image: NEW_PRODUCTS_FEATURE_STOCK_IMAGE_SET,
    mobile_background_image: NEW_PRODUCTS_FEATURE_STOCK_IMAGE_SET,
};

type FeatureSliderProps = {
    slides: Feature[];
    hasPromoProductsCard: boolean;
    hasNoveltyProductsCard: boolean;
    isWithFirstFeatureStock?: boolean;
};
export const FeatureSlider: FunctionComponent<FeatureSliderProps> = (props) => {
    const { slides, hasPromoProductsCard, hasNoveltyProductsCard } = props;

    const { scrollPrev, scrollNext, isPrevButtonEnabled, isNextButtonEnabled, viewportRef } =
        useEmbla({
            loop: false,
            startIndex: 0,
            slidesToScroll: 1,
            containScroll: 'trimSnaps',
            align: 'start',
        });

    const linkElement = (
        { background_image, mobile_background_image, title }: Feature,
        route: string,
        key: number | string,
    ) => (
        <div className={styles.slide} key={key}>
            <Link className={styles.slideInner} route={route}>
                <Picture sources={background_image} alt={title} className={styles.image} />
                <Picture
                    sources={mobile_background_image}
                    alt={title}
                    className={clsx(styles.image, styles.isMobile)}
                />
                <h6 className={styles.title}>{title}</h6>
            </Link>
        </div>
    );

    return (
        <div className={styles.root}>
            <Container classes={{ root: styles.container }}>
                <div className={styles.slider}>
                    <div ref={viewportRef} className={styles.viewport}>
                        <div className={styles.sliderContainer}>
                            {hasPromoProductsCard &&
                                linkElement(
                                    promoFeatureStock,
                                    makeCategoryRoute(PromoPageSlug),
                                    'promo-stock',
                                )}
                            {hasNoveltyProductsCard &&
                                linkElement(
                                    newProductsFeatureStock,
                                    makeCategoryRoute(NewProductsPageSlug),
                                    'novelty-stock',
                                )}
                            {slides.map((feature, index) =>
                                linkElement(
                                    feature,
                                    makeNewsDetailsRoute(feature.news_slug),
                                    index,
                                ),
                            )}
                        </div>
                    </div>

                    <SliderNavigation
                        onPrev={scrollPrev}
                        onNext={scrollNext}
                        isPrevButtonEnabled={isPrevButtonEnabled}
                        isNextButtonEnabled={isNextButtonEnabled}
                        variation="circle"
                        classes={{ button: styles.navigationButton }}
                    />
                </div>
            </Container>
        </div>
    );
};
